import { BsXCircle } from "react-icons/bs";
import { generateIcon } from "utils";

interface IErrorsMessageProps {
  errors: any;
  className?: string;
  isArray?: boolean;
}

export function ErrorsMessage({
  errors,
  className,
  isArray,
}: IErrorsMessageProps) {
  if (!errors) {
    return null;
  }

  if (isArray) {
    return (
      <div className="alert text-error bg-error/20 shadow-lg m-2 ">
        {generateIcon(BsXCircle)}
        <div className="flex flex-col gap-4">
          {errors.map((item: any, idx: number) => (
            <div key={idx} className="text-xxl">
              {item}
            </div>
          ))}
        </div>
      </div>
    );
  }
  return (
    <div
      className={`${
        className || ""
      } flex flex-col justify-center items-start gap-2 my-4 text-error bg-error/20 p-3 rounded-lg`}
    >
      {Object.keys(errors).map((key: any) =>
        errors[key].errors.map((item: any, idx: number) =>
          errors[key].errors.length > 1 ? (
            <>
              {errors[key].errors.map((subError: any, subIdx: number) => (
                <div
                  key={`errorSub_${subIdx}`}
                  className="text-sm font-semibold"
                >
                  {generateIcon(BsXCircle)}
                  {subError.errorMessage}
                </div>
              ))}
            </>
          ) : (
            <div
              key={`error_${idx}`}
              className="flex flex-row gap-2 text-sm font-semibold"
            >
              {generateIcon(BsXCircle)}
              {item.errorMessage}
            </div>
          )
        )
      )}
    </div>
  );
}
